import SubscriptionPackages         from 'scripts/defa/subscription-packages/collection-subscription-packages';
import SubscriptionPackage          from 'scripts/defa/subscription-packages/model-subscription-package';
import SubscriptionPackageCollectionView
	from 'scripts/defa/subscription-packages/view-subscription-package-collection-view';
import SubscriptionPackageContainer from 'scripts/defa/subscription-packages/view-subscription-package-container';
import SubscriptionPackageOptionForm
	from 'scripts/defa/subscription-packages/view-subscription-package-option-form';
import SubscriptionPackagePrepaidFlow
	from 'scripts/defa/subscription-packages/view-subscription-package-prepaid-flow';
import SubscriptionPackageRadioButton
	from 'scripts/defa/subscription-packages/view-subscription-package-radio-button';
import Module                       from 'scripts/module';

const SubscriptionPackagesModule = new Module( 'SubscriptionPackagesModule', {
	collections: {
		SubscriptionPackages
	},
	models     : {
		SubscriptionPackage
	},
	views      : {
		SubscriptionPackageCollectionView,
		SubscriptionPackageContainer,
		SubscriptionPackageOptionForm,
		SubscriptionPackagePrepaidFlow,
		SubscriptionPackageRadioButton
	}
} );
export default SubscriptionPackagesModule;